import React, { Component } from 'react';
import MenuContainer from 'containers/Menu';

export default function withMenu(WrappedComponent, leaveForRight) {
  return class WithMenu extends Component {
    static defaultProps = {
      withBackButton: false,
    };

    render() {
      return (
        <>
          <MenuContainer leaveForRight={leaveForRight} />
          <WrappedComponent {...this.props} />
        </>
      );
    }
  };
}
